import React from 'react'
import { Collapse, Tag, Typography, Timeline } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import image from './assets/images/littlebobo.jpg'

const { Panel } = Collapse;
const { Text } = Typography;
export default function ViewMethod() {
    return (
        <div id="method" className="block methodBlock">
            <div className="container-fluid">
                <div className="titleHolder">
                    <h2><img alt="bobo" src={image} width="60px" height="40px" />徵選辦法</h2>
                    <span>『TUT虛擬數位形象大使』是台南應用科大最有魅力的學伴，充滿藝與美的氣質，完美的溫和個性，關心、陪伴每位同學度過喜怒哀樂的青春歲月。在學確保有教無類、公平以及高品質的教育，畢業後的同學也能繼續終身學習。他的美好，來自於不斷的學習、成長與突破，他總是欣賞每位同學的優點，默默陪伴每位同學，成就同學找到自己最獨特的美好。
                        可參考理念：<a rel="noopener noreferrer" href='https://sdgs.un.org/goals' target='_blank'>聯合國2030永續發展目標 SDGs</a>第四項目標：「確保有教無類、公平以及高品質的教育及提倡終身學習」。
                    </span>
                </div>
                <Collapse defaultActiveKey={['1']}>
                    <Panel header="(一)	活動期程" key="1">
                        <Timeline mode={"right"}>
                            <Timeline.Item label="報名及投稿" color="green">111年9月26日10時-10月10日24時止</Timeline.Item>
                            <Timeline.Item label="評選及票選" color="green">111年10月14日-10月24日止</Timeline.Item>
                            <Timeline.Item label="得獎發佈暨頒獎日期" color="green">111年10月30日(58週年校慶)</Timeline.Item>
                            <Timeline.Item label="TUT虛擬代言人專屬設計師簽約記者會" dot={<ClockCircleOutlined className="timeline-clock-icon" />} color="red">111年12月23日</Timeline.Item>
                        </Timeline>
                    </Panel>
                    <Panel header="(二)	徵稿內容" key="2">
                        <p>請參閱世界觀設定，發展TUT的形象大使IP角色設計。需包含：</p>
                        <ol className='item'>
                            <li>角色設計彩色稿</li>
                            <li>角色Q版繪圖</li>
                            <li>創作理念</li>
                        </ol>
                    </Panel>
                    <Panel header="(三)	參選資格" key="3">
                        <ol className='item'>
                            <li>有興趣參加之<Text underline>校內學生</Text>。</li>
                            <li>曾在任何競賽中入圍及獲獎之作品不得參賽，投件後不得再以同一作品參加其他競賽，違者取消參賽資格。</li>
                            <li>參賽作品須未曾參加任何公開比賽、發表、出版、展出及任何相關授權行為，且不得有抄襲、翻譯、改寫、侵害智慧財產權等違法侵權之情形。如有侵權或抄襲疑慮，將交由本校評審委員決議是否取消參賽資格。若得獎作品有侵權情形，經主辦單位認定屬實則取消得獎資格，除須自行負擔法律責任外，並需立即退還得獎獎金及獎狀。</li>
                            <li>為評選公平起見，上傳作品圖檔上不可署名。</li>
                            <li>本項活動得獎人須同意簽署將得獎作品著作權專屬授權予台南應用科技大學。</li>
                        </ol>
                    </Panel>
                    <Panel header="(四)	作品繳交" key="4">
                        <ol className='item'>
                            <li><Tag color="orange">全身立繪角色設計彩色稿</Tag>：300dpi，A4(橫幅圖)，png檔案，RGB色彩模式。</li>
                            <li><Tag color="orange">角色Q版(2頭身)繪圖彩色稿</Tag>：300dpi，A5(橫幅圖)，png檔案，RGB色彩模式。</li>
                            <li><Tag color="orange">創作理念</Tag>：說明設計特點、人設概念與創作想法， 500字以內（如角色名字、星座、專長、生日、血型、特殊特色、自我介紹)。</li>
                            <li><Tag color="orange">著作權切結書</Tag>著作權切結書：簽署後掃描，團隊每一位作者皆須簽署，電子檔儲存PDF檔上傳。</li>
                        </ol>
                        <div className="quickSupport">
                            <h2><Tag color="magenta">每一人(團隊)限投一稿。</Tag></h2>
                        </div>
                    </Panel>
                    <Panel header="(五)	評選方式及評選結果" key="5">
                        <ol className='item' >
                            <li><Tag color="red">初選</Tag>：由校內專業教師組成評選委員會，進行初選。</li>
                            <li><Tag color="red">決選</Tag>：網路票選(佔70%)與專業評選(佔30%)共同評選。
                                <ol className='item' type="I">
                                    <li>網路票選(佔70%)：本校教職員工生網路票選。<span style={{ color: "blue", fontSize: "0.5em" }}>(註：票選第一名100分；第二名97分；第三名得94分；第四名得91分；第五名得88分；第六名得85分；第七名得82分；第八名得80分)</span></li>
                                    <li>專業評選(佔30%)：本校評選委員會議。<span style={{ color: "blue", fontSize: "0.5em" }}>依①設計理念(30分)、②美感及辨識度(25分)、③創意與適合性(25分)、④運用效果項目評分(20分)</span>。</li>
                                </ol>
                            </li>
                        </ol>
                        <div className="quickSupport">
                            <h2><Tag color="magenta">收件時間：自111年9月26日10:00起至10月10日24:00止。</Tag></h2>
                        </div>
                    </Panel>
                    <Panel header="(六)	作品及著作權" key="6">
                        <ol className='item' >
                            <li>獲獎作品：徵選確定得獎名單後，除得獎者成為本校官方虛擬形象專屬設計師外，並由校方出資發行官方免費貼圖一組，惟校方保有最終修改權。第2-5名作品經校方委員會審查通過後，得以個人帳號發行貼圖，<Text underline>貼圖販售之獲利歸發行人所有，校方不再收取其他費用</Text>。其它參賽者作品電子檔案由本校於活動結束後一星期內作廢處理，不接受參賽者拷貝檔案申請。</li>
                            <li>著作財產權之歸屬：
                                <ol className='item' type="I">
                                    <li>本活動所有繳件的參賽者應簽署著作權確認切結書，其投稿所有內容確無違背現行法規或侵害他人著作權等情事，若有侵害他人智慧財產權及第三人合法權益時，概由參賽者負責處理並承擔一切法律責任。</li>
                                    <li>本活動經評選得獎之作品（前五名及佳作）須簽署著作財產權專屬授權書予台南應用科技大學，本校並保有形象識別應用文件設計使用之最終決定權與重製、修改權利，有不限次數進行各種型態媒體宣傳、展覽、文創品、出版品及網站刊登等印製與傳播，不再另予通知或致酬原作者。</li>
                                    <li>評選後由承辦單位通知得獎者簽署專屬授權書，完成簽署後始具備得獎資格。</li>
                                    <li>參賽作品應未曾在其他比賽參與、獲獎或未曾供他人公開使用，違者經查證屬實，得撤消得獎資格，獎位不遞補，如已領取獎項者，本校得追回獎金及獎狀外並依法求償。</li>
                                </ol>
                            </li>
                        </ol>
                    </Panel>
                </Collapse>

            </div>
        </div>
    )
}
